const i18nService = {
  defaultLanguage: "ptbr",

  languages: [
    {
      lang: "ptbr",
      name: "Portuguese",
      flag: process.env.BASE_URL + "assets/media/flags/255-brazil.svg",
    },
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorage.getItem("language") || this.defaultLanguage;
  },
};

export default i18nService;
